import dayjs from '~/timeInit';

export const DATETIME_LOCAL_FORMAT = 'YYYY-MM-DDTHH:mm';

// Widened datetime formats are accepted only when loading JSON payloads authored outside datetime-local inputs.
export const DATETIME_INPUT_FORMATS: Array<string> = [
  DATETIME_LOCAL_FORMAT,
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  'YYYY-MM-DDTHH:mm:ss[Z]',
];

export function isValidDateTimeInput(value: string): boolean {
  return dayjs(value.trim(), DATETIME_INPUT_FORMATS, true).isValid();
}

export function toDateTimeLocal(value: unknown): string {
  const source = typeof value === 'string' ? value.trim() : '';
  if (!source) return '';

  const parsed = dayjs(source, DATETIME_INPUT_FORMATS, true);
  return parsed.isValid() ? parsed.format(DATETIME_LOCAL_FORMAT) : source;
}
